import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'
import useRouteParser from 'src/hooks/routeParser'

const { t } = useI18n()
const { toInt } = useRouteParser()

const module: RouteRecordRawArgumented = {
  path: 'price-compare',
  name: 'priceCompare',
  redirect: () => ({ name: 'priceCompareLogs' }),
  meta: {
    breadcrumb: {
      name: t('breadcrumb.price_compare.index'),
      icon: 'mdi-scale-balance',
    },
    auth: {
      permission: 'price_compare_access',
    },
  },
  children: [
    {
      path: 'logs',
      name: 'priceCompareLogs',
      component: () =>
        import(
          /* webpackChunkName: "price-compare-logs" */ 'pages/price-compare/LogsPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.price_compare.logs'),
          icon: 'mdi-history',
        },
        auth: {
          permission: 'price_compare_access',
        },
      },
    },
    {
      path: 'logs/:id',
      name: 'priceCompareLogDetails',
      component: () =>
        import(
          /* webpackChunkName: "price-compare-log-details" */ 'pages/price-compare/LogDetailsPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.price_compare.log_details'),
          icon: 'mdi-text-box-outline',
        },
        auth: {
          permission: 'price_compare_access',
        },
        casts: {
          params: {
            id: toInt,
          },
        },
      },
    },
    {
      path: 'simulate',
      name: 'priceCompareSimulate',
      component: () =>
        import(
          /* webpackChunkName: "price-compare-simulate" */ 'pages/price-compare/SimulatePage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.price_compare.simulate'),
          icon: 'mdi-play-circle-outline',
        },
        auth: {
          permission: 'price_compare_access',
        },
      },
    },
  ],
}

export default module
